<template>
  <div>
    <wc-section-title title='Snow'></wc-section-title>
    <router-view></router-view>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'snow-base',
  computed: {
    menu () {
      return [
        {
          title: 'Snow Dashboard',
          icon: 'mdi-snowflake',
          route: { name: 'SnowDashboard' }
        },
        {
          title: 'Snow Project Report',
          icon: 'mdi-file-table',
          route: { name: 'SnowProjectReport' }
        }
      ]
    },
    snowDivision() {
      return _.find(this.$store.state.misc.divisions, d => d.division === 'Snow')
    },
  },
  mounted () {
    this.$store.dispatch('loadMainMenuTitle', 'Snow Menu')
    this.$store.dispatch('loadMainMenu', this.menu)
  }
}
</script>
